export default (() => {
  let listener;

  const registerListener = (fn) => {
    listener = fn;
  };

  const notify = (toast) => {
    if (listener) {
      listener(toast);
    }
  };

  return {
    registerListener,
    notify,
  };
})();
